import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45user_45global from "/var/www/html/src/middleware/01.user.global.ts";
import _02_45authorization_45global from "/var/www/html/src/middleware/02.authorization.global.ts";
import _03_45not_45found_45global from "/var/www/html/src/middleware/03.not-found.global.ts";
import _04_45permissions_45global from "/var/www/html/src/middleware/04.permissions.global.ts";
import manifest_45route_45rule from "/var/www/html/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45user_45global,
  _02_45authorization_45global,
  _03_45not_45found_45global,
  _04_45permissions_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authorization: () => import("/var/www/html/src/middleware/authorization.ts"),
  "no-authorization": () => import("/var/www/html/src/middleware/no-authorization.ts"),
  "register-confirm": () => import("/var/www/html/src/middleware/register-confirm.ts"),
  register: () => import("/var/www/html/src/middleware/register.ts"),
  "reset-password": () => import("/var/www/html/src/middleware/reset-password.ts")
}